'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var useEscape = function useEscape() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onEscape = _ref.onEscape,
      onEscape = _ref$onEscape === void 0 ? noop__default["default"] : _ref$onEscape,
      _ref$preventClose = _ref.preventClose,
      preventClose = _ref$preventClose === void 0 ? false : _ref$preventClose;

  var escapeHandler = react.useCallback(function (event) {
    if (event.key === 'Escape' || event.code === 'Escape' || event.keyCode === 27) {
      onEscape(event);
    }
  }, [onEscape]);
  react.useEffect(function () {
    if (!preventClose) {
      window.addEventListener('keydown', escapeHandler, false);
      return function () {
        window.removeEventListener('keydown', escapeHandler);
      };
    }

    return noop__default["default"];
  }, [escapeHandler, preventClose]);
};

useEscape.HOOK_ID = 'Gearz.ReactHooks.useEscape';
useEscape.returnType = undefined;
useEscape.parameterTypes = {
  parameter: PropTypes__default["default"].shapeWithDescription({
    onEscape: PropTypes__default["default"].funcWithDescription('Callback to execute on escape key pressed.'),
    preventClose: PropTypes__default["default"].boolWithDescription('Flag to activate/deactivate escape key press handler.')
  }, 'Settings of escape key press handler.')
};
useEscape.defaultParameters = {
  parameter: {
    onEscape: noop__default["default"],
    preventClose: false
  }
};

module.exports = useEscape;
